module.exports = __webpack_public_path__ + "static/media/bootstrap-logo.ef38030f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bootstrap-logo.png
// module id = 502
// module chunks = 0